import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.css']
})
export class ConfiguracionComponent implements OnInit {
  safeUrl: SafeResourceUrl;

  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const accessToken = this.authService.getToken();

    const iframeUrl = `${environment.ADMIN_URL}dashboard/configuracion?token=${accessToken}`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/configuracion/configuracion.component.ts